import { useState } from 'react';
import { ouvrirFichierSecurise } from '../utils/fichiersSecurises';

/**
 * Lien vers un document protégé (correctif sécurité) : le fichier est demandé à l'API avec la
 * session de l'utilisateur, qui vérifie son droit sur le salarié ; un refus s'affiche sobrement
 * à côté du lien au lieu d'ouvrir une page d'erreur.
 */
export default function LienFichierSecurise({ chemin, style, children }) {
  const [erreur, setErreur] = useState('');
  const [ouverture, setOuverture] = useState(false);

  const ouvrir = async (e) => {
    e.preventDefault();
    if (ouverture) return;
    setErreur('');
    setOuverture(true);
    const msg = await ouvrirFichierSecurise(chemin);
    setOuverture(false);
    if (msg) setErreur(msg);
  };

  return (
    <>
      <a href="#document" onClick={ouvrir} style={{ cursor: ouverture ? 'progress' : 'pointer', ...style }}>
        {children}
      </a>
      {erreur && <span role="alert" style={{ fontSize: 11, color: '#C62828', marginLeft: 8 }}>{erreur}</span>}
    </>
  );
}
